import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class EncryptDecryptService {

  constructor() { }
  /**
   * This service is created
   * for encrytion/decryption
   * @author : Pooja Gupta
   */

  saltKey: any = '8b9a313860be2494';
  saltKeyALIS: any = '89d8o4Uv62f87av1';
  encryptId: any = '3e76$KLEQ';//salt password
  keySize: number = 256;
  ivSize: number = 128;
  iterations: number = 1024;

  /*** Below methods are used for encrytion/decryption from angular app to java app *****/
  encrypt(dataToEncrypt) {
    const salt = CryptoJS.lib.WordArray.random(128 / 8);
    const key = CryptoJS.PBKDF2(this.encryptId, salt, {
      keySize: this.keySize / 32,
      iterations: this.iterations
    });

    const iv = CryptoJS.lib.WordArray.random(this.ivSize / 8);

    const encrypted = CryptoJS.AES.encrypt(dataToEncrypt, key, {
      iv: iv,
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC

    });

    /**  salt, iv will be hex 32 in length append them to the ciphertext for use  in decryption **/
    return salt.toString() + iv.toString() + encrypted.ciphertext.toString();
  }


  decrypt(dataToDecrypt) {
    var salt = CryptoJS.enc.Hex.parse(dataToDecrypt.substr(0, 32));
    var iv = CryptoJS.enc.Hex.parse(dataToDecrypt.substr(32, 32))
    var encryptedHex = dataToDecrypt.substring(64);

    var key = CryptoJS.PBKDF2(this.encryptId, salt, {
      keySize: this.keySize / 32,
      iterations: this.iterations
    });
    const encryptedText = CryptoJS.enc.Hex.parse(encryptedHex);

    var decrypted = CryptoJS.AES.decrypt({ ciphertext: encryptedText }, key, {
      iv: iv,
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC

    })
    return decrypted.toString(CryptoJS.enc.Utf8);
  }

  /********Below methods  encryption/decryption is for angular to angular app 
   * i.e care portal angular app to Genesys/ALIS angular ***********/
  /**
   * used in genesys for decrypting customer Id where encrypted value flow
   * from genesys angular code
   * @param dataToDecrypt
   * @returns 
   */
  decodeAndDecrypt(dataToDecrypt) {
    // console.log("Method decodeAndDecrypt called dataToDecrypt = ",dataToDecrypt)
    try {
      let _key = CryptoJS.enc.Utf8.parse(this.saltKeyALIS);
      let _iv = CryptoJS.enc.Utf8.parse(this.saltKeyALIS);

      return CryptoJS.AES.decrypt(dataToDecrypt, _key, {
        keySize: 16,
        iv: _iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }).toString(CryptoJS.enc.Utf8);
    } catch (e) {
      console.log(e);
    }
  }

  encodeAndEncrypt(dataToEncrypt) {
    // console.log("Method encodeAndEncrypt called dataToEncrypt = ",dataToEncrypt)
    try {
      let _key = CryptoJS.enc.Utf8.parse(this.saltKeyALIS);
      let _iv = CryptoJS.enc.Utf8.parse(this.saltKeyALIS);

      return CryptoJS.AES.encrypt(dataToEncrypt, _key, {
        keySize: 16,
        iv: _iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }).toString();
    } catch (e) {
      console.log(e);
    }
  }
}
